<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>
<div class="job-posts placements agreements margin-top-service-30px">
  <div class="card skillassest-form">
    <!--<div class="card-header wh-header card-title-schedule-bb card-title-schedule-bl padding-l-8px  padding-bottom padding-top-5">
      Services Configuration
    </div>-->



  </div>
  <div class="card-body padding-top padding-left-0px padding-right-0px">
    <div class="row">

      <div class="position-fixed-service border-right2 padding-right-0px">
        <div class="card">

          <div class="card-header wh-header header3 padding-right-32px bk-color-light padding-bottom-0px">
            <div class="row margin-top10px margin-left-20px  nav-link-hand" (click)="back()">

              <label class="wh-header font-weight-normal card-title-schedule-bl border-radius-4px padding-top-10px padding-bottom-4px margin-bottom-0px bk-color-light">
                Material Tracking
              </label>
              <a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Tests"
                 *ngIf="ShowIcon" (click)="back()"><i class="fas fa-angle-double-left font-size-19px"></i></a>

            </div>
            <div class="row">

              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 padding-left-8px padding-right-0px">
                <div class="row margin-left-0px margin-right-0px margin-top-5px">
                  <div class="col-md-9 padding-left-3px">
                    <label class="margin-bottom-0px font-weight-normal">Select Store</label>
                  </div>

                </div>


                <div class="row margin-left-0px margin-top-5px margin-bottom-5px">
                  <div class="col-md-12 padding-left-0px my-profile-form">
                    <CustomDataByRequestType RequestedType="AccessibleStores"
                                             FacilityCode={{FacilityCode}} ActorCode={{ActorCode2}} class="form-group" SelectedValue="StoreCode"
                                             [(ngModel)]="StoreCode"
                                             (dataLoaded)="StoreList_loaded"
                                             (keyChange)="onAssignedToActorCodesurgeon2($event)"
                                             name="StoreCodename" #sign2="ngModel">
                    </CustomDataByRequestType>
                  </div>
                </div>

              </div>

            </div>



          </div>
          <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-light">
            <div class="row border-top border-bottom padding-top-10px padding-bottom-10px margin-right-0px margin-left16px">
              <div class="col-md-10 padding-right-0px padding-left-0px margin-left-17px display-inherit">
                <form novalidate="" #f="ngForm" class="display-inherit">
                  <div class="clear-form">
                    <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchValue" name="searchBar" [value]='searchValue' maxlength="15">
                    <a (click)="ClearInput()" class="nav-link-hand" title="Clear" *ngIf="searchValue!=null"><span class="clear-icon"><i class="fa fa-times"></i></span></a>
                  </div>
                  <button (click)="criteriaChange(searchValue)" class="btn font-size-13px actions-btn-prime Go-button margin-right-auto margin-left-5px">Go</button>
                </form>
              </div>
              <!--<div class="col-md-2 padding-top-2px padding-left-10px">
                <button type="button" class="btn btn-new btn-sm" tooltip="Add"><i class="fas fa-plus nav-link-hand"></i></button>

              </div>-->


            </div>
            <div>
              <div class="chatsd product-chart-wrapper product-chat-width-97 agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                <div class="row border-bottom rowfor margin-left16px nav-link-hand edit_hover_class" (click)="Selectedlab(l)" *ngFor="let l of pdata">

                  <div class="col-md-10">

                    <label class="margin-bottom-0px nav-link-hand font-size-13px margin-left-5px">{{l.Description}}</label>
                  </div>
                  <!--<div class="col-md-2 padding-left-0px">
                    <a> <i class="fas fa-pencil-alt nav-link-hand"></i></a>
                  </div>-->

                </div>

                <!--<div class="row border-bottom rowfor margin-left16px nav-link-hand edit_hover_class" (click)="viewservice1()">

                  <div class="col-md-10">

                    <label class="margin-bottom-0px nav-link-hand font-size-13px margin-left-5px">Harmonal Assay</label>
                  </div>
                  <div class="col-md-2 padding-left-0px">
                    <a> <i class="fas fa-pencil-alt nav-link-hand"></i></a>
                  </div>

                </div>-->

              </div>
            </div>

          </div>

        </div>
      </div>
      <div class="offset-md-2 col-md-10 padding-left-42px" *ngIf="ShowService">
        <div class="card">

        </div>
        <div class="row">
          <div class="col-md-12 padding-left-0px">
            <div class="card">
              <div class="card-header wh-header border-bottom padding-top-5px padding-left-5px padding-bottom-5px">
                <div class="row" *ngIf="SelectedlabDetails">
                  <div class="col-md-4 padding-right-0px padding-left-0px">
                    <div class="row font-size-16px">
                      <div class="col-md-5 padding-right-4px text-align-right padding-left-0px">
                        <label class="font-weight-bold font-size-15px margin-bottom-0px">Selected Material </label>
                      </div>-
                      <div class="col-md-6 padding-right-0px padding-left-5px text-align-left">
                        <label class="font-weight-bold font-size-15px margin-bottom-0px color-Assign nav-link-hand"
                               (click)="EditMaterialDetails(SelectedlabDetails)">
                          <!--<a *canUserAccess="['HL_ER_EditMaterialDetails']"
                             (click)="EditMaterialDetails(SelectedlabDetails)" class="nav-link-hand education-navlink" title="Edit">
                            <span class="badge font-size-14 padding-left-0px padding-right-5px"><i class="fas fa-pencil-alt"></i></span>
                          </a>-->
                          {{SelectedlabDetails.Description}}

                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 padding-right-0px padding-left-0px">
                    <div class="row font-size-16px">
                      <div class="col-md-4 padding-right-4px text-align-right padding-left-0px">
                        <label class="font-weight-bold font-size-15px margin-bottom-0px">Group Name </label>
                      </div>-
                      <div class="col-md-7 padding-right-0px padding-left-5px text-align-left">
                        <label class="font-weight-bold font-size-15px margin-bottom-0px color-Assign">{{SelectedlabDetails.GroupName}}</label>
                      </div>
                    </div>
                  </div>
                  <!--<div class="col-md-3 padding-right-0px"><label class="label-size-2 font-color-secondary">Selected Material</label></div>:
                  <div class="col-md-4 text-align-left"><label class="label-size-2">{{SelectedlabDetails.Description}}</label></div>-->
                  <!--<div class="col-md-3 padding-right-0px"><label class="label-size-2 font-color-secondary"> Group Name</label></div>:
                  <div class="col-md-4 text-align-left"><label class="label-size-2">{{SelectedlabDetails.GroupName}}</label></div>-->
                  <!--<div class="col-md-4 padding-left-0px">
                    <div class="row margin-left-zero margin-right-0px">
                      <div class="col-md-8 padding-right-0px float-left">
                        <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                      </div>

                      <div class="col-md-3 padding-right-8px padding-bottom-4px padding-top-4px rowfor1">
                        <a class="float-right" (click)="addtestmodal()"><i class="fas fa-plus nav-link-hand"></i><label class="margin-bottom-0px padding-left-5px font-size-18px">Tests</label></a>
                      </div>


                    </div>
                  </div>-->
                </div>
              </div>
              <div class="card-body padding-top-0px">
                <div class="row border-bottom-1px">
                  <div class="col-md-12 padding-right-0px">
                    <div class="row padding-top-5px padding-bottom-5px">
                      <div class="col-md-1 max-width-6pe padding-right padding-left-0px text-align-right margin-top-5px margin-left-4px">
                        <label class="margin-right-3px margin-bottom-0px font-size-16px font-weight-bold">Store :</label>
                      </div>
                      <div class="col-md-4">

                        <label class="margin-bottom-0px margin-top-5px color-Assign">{{StoreName}}</label>
                        <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
                        [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
                        name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->
                        <!--<h4 class="color-Assign margin-bottom-0px font-weight-bold margin-top-3px">4116</h4>-->
                      </div>

                      <div class="col-md-1 padding-right padding-left-0px margin-top-5px">
                        <label class="margin-right-3px margin-bottom-0px font-size-16px font-weight-bold">From Date :</label>
                      </div>
                      <div class="col-md-2 padding-left-0px padding-right-0px max-width-10pe">
                        <div class="date-form">
                          <input class="form-control border-top-0 border-left-0 border-right-0 border-bottom-0px border-radius-2px font-size-16px data-color-new" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                                 name="SelectedFrom" [(ngModel)]="SelectedFromDate" ngbDatepicker #d="ngbDatepicker">

                          <a (click)="d.toggle()" class="nav-link-hand">
                            <span class="date-icon margin-top-3px"><i class="far fa-calendar-alt"></i></span>

                          </a>

                        </div>
                      </div>
                      <div class="col-md-1 padding-right  margin-top-5px">
                        <label class="margin-right-3px margin-bottom-0px font-size-16px font-weight-bold">To Date :</label>
                      </div>
                      <div class="col-md-2 padding-left-0px padding-right-0px max-width-10pe">
                        <div class="date-form">
                          <input class="form-control border-top-0 border-left-0 border-right-0 border-bottom-0px border-radius-2px font-size-16px data-color-new" placeholder="To Date" [minDate]="minDate" [maxDate]="maxDate"
                                 name="SelectedTo" [(ngModel)]="SelectedToDate" ngbDatepicker #d1="ngbDatepicker">

                          <a (click)="d1.toggle()" class="nav-link-hand">
                            <span class="date-icon margin-top-3px"><i class="far fa-calendar-alt"></i></span>

                          </a>

                        </div>
                      </div>



                      <!--<div class="col-md-3 float-right padding-right-0px padding-l-0px display-inherit">
                        <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>

                      </div>-->
                      <div class="max-width-12pe padding-left-0px padding-top-3px">
                        <button class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-10px" (click)="Go()">Go</button>
                        <a class="nav-link-hand education-navlink data-color-new margin-left-10px" title="print" (click)="printmaterial()">
                          <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                        </a>
                        <!--<button class="btn font-size-13px actions-btn-prime  margin-left-5px" title="print" (click)="printexpenses()">GetReport</button>-->
                      </div>
                      <div class="col-md-1 padding-left-0px">

                      </div>
                      <!--<div class="max-width-12pe padding-left-0px">
                        <button class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-10px" (click)="LoadForms()">Go</button>
                        <button class="btn font-size-13px actions-btn-prime  margin-left-5px" title="print" (click)="printexpenses()">GetReport</button>
                      </div>-->
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">


                    <ul class="nav nav-tabs nav-tab-service2 margin-top-13px" id="tabContent">
                      <li class="active margin-right-15px"><a class="nav-itemerp active" href="#batches" data-toggle="tab">Batches</a></li>
                      <li class="margin-right-15px"><a class="nav-itemerp" href="#sales" data-toggle="tab">Sales</a></li>
                      <!--<li class="margin-right-15px"><a class="nav-itemerp" href="#purchases" data-toggle="tab">Purchases</a></li>-->
                      <li class="margin-right-15px"><a class="nav-itemerp" href="#returns" data-toggle="tab">Returns</a></li>
                      <li class="margin-right-15px"><a class="nav-itemerp" href="#verifications" data-toggle="tab">Verifications</a></li>
                      <li class="margin-right-15px"><a class="nav-itemerp" href="#transfers" data-toggle="tab">Transfers</a></li>
                    </ul>

                    <div class="tab-content">

                      <div class="tab-pane active" id="batches">
                        <div class="row margin-left-10px margin-top-5px" *ngIf="length>0">

                          <div class="col-md-2 mistable-data2">
                            <div class="row margin-left-0px font-size-12px font-weight-bold">
                              Total Btch Qty
                            </div>
                            <div class="row margin-left-0px misdatafont" *ngIf="TotalBatchqty">
                              {{TotalBatchqty}}
                            </div>
                          </div>
                          <div class="col-md-2 mistable-data2">
                            <div class="row margin-left-0px font-size-12px font-weight-bold">
                              Total Avl Qty
                            </div>
                            <div class="row margin-left-0px misdatafont" *ngIf="TotalAvlqty">
                              {{TotalAvlqty}}
                            </div>
                          </div>
                        </div>
                        <div class="row margin-top-5px" *ngIf="length>0">
                          <div class="col-md-12">

                            <div class="table-component">
                              <div class="table-responsive overflow-x">


                                <table class="table table-striped margin-left-20p table-fixed"
                                       cols="auto,2*,*,*,*,*,*,*">

                                  <thead class="">
                                    <tr>


                                      <th class=" padding-top-4px padding-bottom-4px th-sticky padding-left-9px">
                                        Entry Date
                                      </th>

                                      <th class=" padding-top-4px padding-bottom-4px th-sticky padding-left-0px ">
                                        HsnCode
                                      </th>
                                      <th class="padding-top-4px padding-bottom-4px th-sticky padding-left-9px">
                                        Supplier
                                      </th>
                                      <th class=" padding-top-4px padding-bottom-4px th-sticky padding-left-0px ">
                                        Batch
                                      </th>
                                      <th class=" padding-top-4px padding-bottom-4px th-sticky padding-left-0px ">
                                        Expiry Date
                                      </th>
                                      <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-5px">
                                        Tax(%)
                                      </th>

                                      <th class=" padding-top-4px padding-bottom-4px th-sticky padding-right-0px">
                                        Batch qty
                                      </th>
                                      <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-0px">
                                        Avl.qty
                                      </th>
                                      <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-0px">
                                      </th>
                                      <!--<th class="padding-top-4px padding-bottom-4px th-sticky padding-right-0px">
                  </th>-->
                                    </tr>
                                  </thead>

                                  <tbody class="table-body">
                                    <tr *ngFor="let l of CurrentMaterialBatchInaStoreController;let i = index">



                                      <td class="td-padding-tb  padding-right-0px"> <label class="margin-bottom-0px">{{l.EntryDate | date:'MMM-dd-yyyy'}}</label></td>
                                      <td class=" td-padding-tb  padding-left-2px text-align-center padding-right-4pe">{{l.HsnCode}}</td>
                                      <td class=" td-padding-tb padding-right-0px">{{l.SupplierShortName}}</td>
                                      <td class="td-padding-tb padding-right-0px padding-left-2px">{{l.BatchNo}}</td>
                                      <td class="td-padding-tb padding-right-0px padding-left-2px"><label class="margin-bottom-0px">{{l.ExpiryDate | date:'MMM-dd-yyyy'}}</label></td>
                                      <td class="td-padding-tb text-align-center padding-right-4pe">{{l.TaxPercent}}</td>
                                      <td class="td-padding-tb text-align-center padding-right-4pe">{{l.BatchQuantity}}</td>
                                      <td class="td-padding-tb text-align-center padding-right-4pe">{{l.AvailableQuantity}}</td>
                                      <td class="td-padding-tb text-align-center padding-right-4pe">
                                        <button *canUserAccess="['HL_ER_20']"
                                                (click)="ReturnMaterial(l)"
                                                class="btn btn-link padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" title="Return">
                                          <i class="fas fa-redo color-cycle-icon"></i>
                                        </button>
                                        <a *canUserAccess="['HL_ER_21']"
                                           (click)="VerifyMaterial(l)" class="nav-link-hand education-navlink" title="Verify">
                                          <span class="badge font-size-14 padding-right-0px"><i class="fa fa-check color-green"></i></span>
                                        </a>
                                        <a *canUserAccess="['HL_ER_22']"
                                           (click)="TransferMaterial(l)" class="nav-link-hand education-navlink" title="Transfer">
                                          <span class="badge font-size-14 padding-right-0px">
                                            <img src='p-transfer.png'
                                                 [style.width.px]="18"
                                                 [style.height.px]="18">
                                          </span>
                                        </a>
                                        <a *canUserAccess="['HL_ER_19']"
                                           (click)="CopyMaterial(l)" class="nav-link-hand education-navlink" title="Copy">
                                          <span class="badge font-size-14 padding-right-0px"><i class="far fa-copy"></i></span>
                                        </a>
                                        <a *canUserAccess="['HL_ER_14']"
                                           (click)="EditQty(l)" class="nav-link-hand education-navlink" title="Edit">
                                          <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                                        </a>
                                        <a *canUserAccess="['HL_ER_13']"
                                           (click)="SelectedMaterial(l)"
                                           class="nav-link-hand font-size-16px color-Rejected" title="Remove">
                                          <i class="far fa-trash-alt nav-link-hand"></i>
                                        </a>
                                      </td>
                                      <!--<td class="td-padding-tb text-align-center padding-right-4pe">
                    <a
                       (click)="SelectedMaterial(l)"
                       class="nav-link-hand font-size-16px color-Rejected" title="Remove">
                      <i class="far fa-trash-alt nav-link-hand"></i>
                    </a>
                  </td>-->
                                    </tr>
                                  </tbody>



                                </table>
                              </div>
                            </div>

                          </div>
                        </div>
                        <div class="row" *ngIf="length==0">
                          <div class="col-md-12 padding-left-0px text-align-center">
                            <label class="margin-bottom-0px color-Assign font-size-18px margin-top-3px">
                              Batches are not avilable for this Material.
                            </label>
                          </div>
                        </div>
                        <!--<div class="row margin-top-5px margin-bottom-5px">
      <div class=" offset-md-8 col-md-4">
        <div class="row font-size-12px">

          <div class="col-md-6 margin-left-auto text-align-right padding-right-10px">
            <h4 class="font-weight-normal font-size-12px margin-bottom-0px">Total Btch Qty </h4>
          </div>:
          <div class="col-md-3 padding-right-0px padding-left-10px">
            <h4 class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{TotalBatchqty}}</h4>
          </div>
        </div>
      </div>
    </div>
    <div class="row margin-top-5px margin-bottom-5px">
      <div class=" offset-md-8 col-md-4">
        <div class="row font-size-12px">

          <div class="col-md-6 margin-left-auto text-align-right padding-right-10px">
            <h4 class="font-weight-normal font-size-12px margin-bottom-0px">Total Avl Qty </h4>
          </div>:
          <div class="col-md-3 padding-right-0px padding-left-10px">
            <h4 class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{TotalAvlqty}}</h4>
          </div>
        </div>
      </div>
    </div>-->
                      </div>

                      <div class="tab-pane" id="sales">

                        <div class="row margin-left-10px margin-top-5px margin-right-7px" *ngIf="length2>0">
                          <!--<div class="col-md-3 margin-left-10px margin-top-5px">
        <div class="card Ipbillcard-border">
          <div class="card-body padding-all-8px">
            <div class="row">
              <div class="col-md-6">
                <label class="margin-bottom-0px font-size-14">Total Advance</label>
              </div>:
              <div class="col-md-5">

                <label class="margin-bottom-0px font-size-14">25000</label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label class="margin-bottom-0px font-size-14">Total Bill</label>
              </div>:
              <div class="col-md-5">
                <label class="margin-bottom-0px font-size-14">45000</label>
              </div>
            </div>
            <div class="row border-top-due">
              <div class="col-md-6">
                <label class="margin-bottom-0px font-size-14">Due</label>
              </div>:
              <div class="col-md-5">
                <label class="margin-bottom-0px font-size-14">20000</label>
              </div>
            </div>
          </div>
        </div>
      </div>-->
                          <div class="col-md-2 mistable-data2 margin-all-0px">
                            <div class="row margin-left-0px font-size-12px font-weight-bold">
                              No.of Sales
                            </div>
                            <div class="row margin-left-0px misdatafont" *ngIf="nofsales">
                              {{nofsales}}
                            </div>
                          </div>
                          <div class="col-md-2 mistable-data2 margin-all-0px">
                            <div class="row margin-left-0px font-size-12px font-weight-bold">
                              Grand Total
                            </div>
                            <div class="row margin-left-0px misdatafont" *ngIf="GrandTotal">
                              {{GrandTotal| number:'1.2-2' |removeComma}}
                            </div>
                          </div>
                          <div class="col-md-2 mistable-data2 margin-all-0px">
                            <div class="row margin-left-0px font-size-12px font-weight-bold">
                              Total Discount
                            </div>
                            <div class="row margin-left-0px misdatafont" *ngIf="TotalDiscountsa">
                              {{TotalDiscountsa| number:'1.2-2' |removeComma}}
                            </div>
                          </div>
                          <div class="col-md-2 mistable-data2 margin-all-0px">
                            <div class="row margin-left-0px font-size-12px font-weight-bold">
                              Total Tax
                            </div>
                            <div class="row margin-left-0px misdatafont" *ngIf="TotalTax">
                              {{TotalTax| number:'1.2-2' |removeComma}}
                            </div>
                          </div>
                          <div class="col-md-2 mistable-data2 margin-all-0px">
                            <div class="row margin-left-0px font-size-12px font-weight-bold">
                              Total Amount
                            </div>
                            <div class="row margin-left-0px misdatafont" *ngIf="Totalsales">
                              {{Totalsales| number:'1.2-2' |removeComma}}
                            </div>
                          </div>
                          <div class="col-md-2 mistable-data2 margin-all-0px">
                            <div class="row margin-left-0px font-size-12px font-weight-bold">
                              Sale Quantity
                            </div>
                            <div class="row margin-left-0px misdatafont" *ngIf="SaleQuantity">
                              {{SaleQuantity}}
                            </div>
                          </div>
                        </div>
                        <div class="row margin-top-5px" *ngIf="length2>0">
                          <div class="col-md-12">

                            <div class="table-component">
                              <div class="table-responsive overflow-x">


                                <table class="table table-striped margin-left-20p table-fixed"
                                       cols="auto,2*,*,*,*,*,*,*">

                                  <thead class="">
                                    <tr>


                                      <th class="padding-top-4px padding-bottom-4px th-sticky padding-left-9px">
                                        Date
                                      </th>

                                      <th class=" padding-top-4px padding-bottom-4px th-sticky padding-left-0px">
                                        Patient
                                      </th>
                                      <th class="padding-top-4px padding-bottom-4px th-sticky">
                                        Qty
                                      </th>
                                      <th class=" padding-top-4px padding-bottom-4px th-sticky padding-left-0px">
                                        Price
                                      </th>

                                      <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-0px">
                                        Item Total
                                      </th>

                                      <th class="padding-top-4px padding-bottom-4px th-sticky">
                                        Disc
                                      </th>
                                      <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-0px">
                                        Before Tax
                                      </th>
                                      <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-0px padding-left-8px">
                                        Tax Amount
                                      </th>

                                      <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-5px padding-left-5px">
                                        Net Amount
                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody class="table-body">
                                    <tr *ngFor="let l of CurrentItemWiseSalesController;let i = index">



                                      <td class="td-padding-tb  padding-right-0px"> <label class="margin-bottom-0px">{{l.BillDate | date:'MMM-dd-yyyy'}}</label></td>
                                      <td class="td-padding-tb padding-right-0px padding-left-2px td-elipsis-mt">{{l.PatientName}}</td>
                                      <td class="text-align-center td-padding-tb padding-right-4pe">{{l.Quantity}}</td>
                                      <td class="text-align-center td-padding-tb padding-right-4pe padding-left-0px">{{l.UnitPrice}}</td>
                                      <td class="td-padding-tb padding-right-8px text-align-center padding-left-0px">{{(l.Quantity * l.UnitPrice)| number:'1.2-2' |removeComma}}</td>
                                      <td class="text-align-center td-padding-tb padding-left-0px">{{l.Discount| number:'1.2-2' |removeComma}}</td>
                                      <td class="text-align-center td-padding-tb padding-left-0px padding-right-5px">{{l.AfterDiscount| number:'1.2-2' |removeComma}}</td>
                                      <td class="text-align-center td-padding-tb padding-left-0px padding-right-0px">{{l.TaxAmount| number:'1.2-2' |removeComma}}</td>
                                      <td class="td-padding-tb padding-right-3px text-align-center padding-left-0px">{{l.Total| number:'1.2-2' |removeComma}}</td>

                                    </tr>
                                  </tbody>



                                </table>
                              </div>
                            </div>

                          </div>
                        </div>

                        <div class="row" *ngIf="length2==0">
                          <div class="col-md-12 padding-left-0px text-align-center">
                            <label class="margin-bottom-0px color-Assign font-size-18px margin-top-3px">
                              Sales are not avilable for this Material.
                            </label>
                          </div>
                        </div>



                      </div>

                      <!--<div class="tab-pane" id="purchases">
    <div class="row">
      <div class="col-md-12 padding-left-0px text-align-center">
        <label class="margin-bottom-0px color-Assign font-size-18px margin-top-3px">
          Purchases are not avilable for this Material.
        </label>
      </div>
    </div>



  </div>-->

                      <div class="tab-pane" id="returns">
                        <div class="row margin-top-5px">
                          <div class="col-md-12 float-right">
                            <button class="btn btn-profile actions-btn-prime-profile2 nav-link-hand font-size-13px margin-right-15px float-right"
                                    (click)="printallreturnedmaterial()">
                              <i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> Print
                            </button>
                          </div>
                        </div>
                        <div class="row margin-top-5px">
                          <div class="col-md-12">

                            <div class="table-component">
                              <div class="table-responsive overflow-x">


                                <table class="table table-striped margin-left-20p table-fixed"
                                       cols="auto,2*,*,*,*,*,*,*">

                                  <thead class="">
                                    <tr>


                                      <th class=" padding-top-4px padding-bottom-4px th-sticky padding-left-9px">
                                        Date
                                      </th>

                                      <th class=" padding-top-4px padding-bottom-4px th-sticky padding-left-0px ">
                                        Material
                                      </th>
                                      <th class="padding-top-4px padding-bottom-4px th-sticky padding-left-9px">
                                        Supplier
                                      </th>
                                      <th class=" padding-top-4px padding-bottom-4px th-sticky padding-left-0px ">
                                        Batch
                                      </th>
                                      <!--<th class=" padding-top-4px padding-bottom-4px th-sticky padding-left-0px ">
                    Expiry Date
                  </th>-->
                                      <th class=" padding-top-4px padding-bottom-4px th-sticky padding-right-0px">
                                        Return qty
                                      </th>
                                      <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-0px">
                                        Reason
                                      </th>
                                      <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-0px">
                                        Remarks
                                      </th>
                                      <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-0px">
                                        User
                                      </th>
                                      <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-0px">

                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody class="table-body">
                                    <tr *ngFor="let l of CurrentPurchaseReturnsController;let i = index">



                                      <td class="td-padding-tb  padding-right-0px"> <label class="margin-bottom-0px">{{l.ReturnDate | date:'MMM-dd-yyyy'}}</label></td>
                                      <td class=" td-padding-tb  padding-left-2px padding-right-4pe">{{l.Description}}</td>
                                      <td class=" td-padding-tb padding-right-0px">{{l.VendorName}}</td>
                                      <td class="td-padding-tb padding-right-0px padding-left-2px">{{l.BatchNo}}</td>
                                      <!--<td class="td-padding-tb padding-right-0px padding-left-2px"><label class="margin-bottom-0px">{{l.ExpDate | date:'MMM-dd-yyyy'}}</label></td>-->
                                      <td class="td-padding-tb text-align-center padding-right-4pe">{{l.ReturnQuantity}}</td>
                                      <td class="td-padding-tb padding-right-4pe">{{l.Reason}}</td>
                                      <td class="td-padding-tb padding-right-4pe">{{l.Remarks}}</td>
                                      <td class="td-padding-tb">
                                        {{l.UserName}}
                                      </td>
                                      <td class="td-padding-tb padding-right-4pe">
                                        <a class="nav-link-hand education-navlink data-color-new margin-left-10px" title="print" (click)="SelectedReturn(l)">
                                          <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                                        </a>
                                      </td>
                                    </tr>
                                  </tbody>



                                </table>
                              </div>
                            </div>

                          </div>
                        </div>
                        <div class="row" *ngIf="length3==0">
                          <div class="col-md-12 padding-left-0px text-align-center">
                            <label class="margin-bottom-0px color-Assign font-size-18px margin-top-3px">
                              Returns are not avilable for this Material.
                            </label>
                          </div>
                        </div>

                      </div>

                      <div class="tab-pane" id="verifications">
                        <div class="row margin-top-5px">
                          <!--<div class="col-md-12 float-right">
                            <button class="btn btn-profile actions-btn-prime-profile2 nav-link-hand font-size-13px margin-right-15px float-right"
                                    (click)="printallreturnedmaterial()">
                              <i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> Print
                            </button>
                          </div>-->
                        </div>
                        <div class="row margin-top-5px">
                          <div class="col-md-12">

                            <div class="table-component">
                              <div class="table-responsive overflow-x">


                                <table class="table table-striped margin-left-20p table-fixed"
                                       cols="auto,2*,*,*,*,*,*,*">

                                  <thead class="">
                                    <tr>


                                      <th class=" padding-top-4px padding-bottom-4px th-sticky padding-left-9px">
                                        Date
                                      </th>

                                      <th class=" padding-top-4px padding-bottom-4px th-sticky padding-left-0px ">
                                        Material
                                      </th>
                                      <th class="padding-top-4px padding-bottom-4px th-sticky padding-left-9px">
                                        Supplier
                                      </th>
                                      <th class=" padding-top-4px padding-bottom-4px th-sticky padding-left-0px ">
                                        Batch
                                      </th>
                                      <th class=" padding-top-4px padding-bottom-4px th-sticky padding-right-0px">
                                        Book qty
                                      </th>
                                      <th class=" padding-top-4px padding-bottom-4px th-sticky padding-right-0px">
                                        Actual qty
                                      </th>
                                      <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-0px">
                                        Reason
                                      </th>
                                      <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-0px">
                                        Remarks
                                      </th>
                                      <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-0px">
                                        User
                                      </th>
                                      <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-0px">

                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody class="table-body">
                                    <tr *ngFor="let l of CurrentMaterialVerificationController;let i = index">



                                      <td class="td-padding-tb  padding-right-0px"> <label class="margin-bottom-0px">{{l.VerifiedDate | date:'MMM-dd-yyyy'}}</label></td>
                                      <td class=" td-padding-tb  padding-left-2px padding-right-4pe">{{l.Description}}</td>
                                      <td class=" td-padding-tb padding-right-0px">{{l.VendorName}}</td>
                                      <td class="td-padding-tb padding-right-0px padding-left-2px">{{l.BatchNo}}</td>
                                      <td class="td-padding-tb text-align-center padding-right-4pe">{{l.BookQuantity}}</td>
                                      <td class="td-padding-tb text-align-center padding-right-4pe">{{l.ActualQuantity}}</td>
                                      <td class="td-padding-tb padding-right-4pe">{{l.Reason}}</td>
                                      <td class="td-padding-tb padding-right-4pe">{{l.Remarks}}</td>
                                      <td class="td-padding-tb">
                                        {{l.UserName}}
                                      </td>
                                      <!--<td class="td-padding-tb padding-right-4pe">
                                        <a class="nav-link-hand education-navlink data-color-new margin-left-10px" title="print" (click)="SelectedReturn(l)">
                                          <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                                        </a>
                                      </td>-->
                                    </tr>
                                  </tbody>



                                </table>
                              </div>
                            </div>

                          </div>
                        </div>
                        <div class="row" *ngIf="length5==0">
                          <div class="col-md-12 padding-left-0px text-align-center">
                            <label class="margin-bottom-0px color-Assign font-size-18px margin-top-3px">
                              Verifications are not avilable for this Material.
                            </label>
                          </div>
                        </div>

                      </div>

                      <div class="tab-pane" id="transfers">
                        <div class="row margin-top-5px">
                          <!--<div class="col-md-12 float-right">
        <button class="btn btn-profile actions-btn-prime-profile2 nav-link-hand font-size-13px margin-right-15px float-right"
                (click)="printallreturnedmaterial()">
          <i class="fa fa-print nav-link-hand font-size-12px margin-top-5px"></i> Print
        </button>
      </div>-->
                        </div>
                        <div class="row margin-top-5px">
                          <div class="col-md-12">

                            <div class="table-component">
                              <div class="table-responsive overflow-x">


                                <table class="table table-striped margin-left-20p table-fixed"
                                       cols="auto,2*,*,*,*,*,*,*">

                                  <thead class="">
                                    <tr>


                                      <th class=" padding-top-4px padding-bottom-4px th-sticky padding-left-9px">
                                        Date
                                      </th>

                                      <th class=" padding-top-4px padding-bottom-4px th-sticky padding-left-0px ">
                                        Material
                                      </th>
                                      <th class="padding-top-4px padding-bottom-4px th-sticky padding-left-9px">
                                        Supplier
                                      </th>
                                      <th class=" padding-top-4px padding-bottom-4px th-sticky padding-left-0px ">
                                        Batch
                                      </th>
                                      <th class=" padding-top-4px padding-bottom-4px th-sticky padding-left-0px ">
                                        From Store
                                      </th>
                                      <th class=" padding-top-4px padding-bottom-4px th-sticky padding-left-0px ">
                                        To Store
                                      </th>
                                      <th class=" padding-top-4px padding-bottom-4px th-sticky padding-right-0px">
                                        Transfer qty
                                      </th>
                                      <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-0px">
                                        Remarks
                                      </th>
                                      <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-0px">
                                        Receiving User
                                      </th>
                                      <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-0px">

                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody class="table-body">
                                    <tr *ngFor="let l of CurrentStockTransfersController;let i = index">



                                      <td class="td-padding-tb  padding-right-0px"> <label class="margin-bottom-0px">{{l.TransferDate | date:'MMM-dd-yyyy'}}</label></td>
                                      <td class=" td-padding-tb  padding-left-2px padding-right-4pe">{{l.Description}}</td>
                                      <td class=" td-padding-tb padding-right-0px">{{l.VendorName}}</td>
                                      <td class="td-padding-tb padding-right-0px padding-left-2px">{{l.BatchNo}}</td>
                                      <td class="td-padding-tb padding-right-0px padding-left-2px">{{l.FromStore}}</td>
                                      <td class="td-padding-tb padding-right-0px padding-left-2px">{{l.ToStore}}</td>
                                      <td class="td-padding-tb text-align-center padding-right-4pe">{{l.TransferQuantity}}</td>
                                      <td class="td-padding-tb padding-right-4pe">{{l.Remarks}}</td>
                                      <td class="td-padding-tb">
                                        {{l.ReceivingUser}}
                                      </td>
                                      <!--<td class="td-padding-tb padding-right-4pe">
                    <a class="nav-link-hand education-navlink data-color-new margin-left-10px" title="print" (click)="SelectedReturn(l)">
                      <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                    </a>
                  </td>-->
                                    </tr>
                                  </tbody>



                                </table>
                              </div>
                            </div>

                          </div>
                        </div>
                        <div class="row" *ngIf="length4==0">
                          <div class="col-md-12 padding-left-0px text-align-center">
                            <label class="margin-bottom-0px color-Assign font-size-18px margin-top-3px">
                              Transfers are not avilable for this Material.
                            </label>
                          </div>
                        </div>

                      </div>





                    </div>
                  </div>
                </div>
                <!--<div class="table-component">
                  <div class="table-responsive overflow-x-hidden">


                    <table class="table table-striped margin-left-zero">

                      <thead class="">
                        <tr>
                          <th class="td-width-3px">Code</th>

                          <th class="">Name</th>

                          <th class="">Lab Department </th>
                          <th class="">Profile</th>



                          <th class="">Service Code</th>

                        </tr>
                      </thead>
                      <tbody class="table-body">
                        <tr *ngFor="let l of CurrentTestsByLabCodeController">
                          <td><a (click)="ViewServiceDetails(l)" class="nav-link-hand table-anchor">{{l.Code !== undefined ? l.Code : l.code}}</a></td>
                          <td><a (click)="ViewServiceDetails(l)" class="nav-link-hand table-anchor">{{l.Name || l.name || l.TestName || l.testName}}</a></td>
                          <td class="">
                            <a class="nav-link-hand table-anchor">{{l.CategoryName || l.categoryName || l.LabDepartmentName || l.labDepartmentName}}</a>
                          </td>
                          <td class="">
                            <a class="nav-link-hand table-anchor">{{l.ProfileName || l.profileName || (l.AgeProfile == 1 ? 'Female' : l.AgeProfile == 2 ? 'Male' : 'All')}}</a>
                          </td>
                          <td class="">
                            <a class="nav-link-hand table-anchor">{{l.ServiceCode !== undefined ? l.ServiceCode : l.serviceCode}}</a>
                          </td>
                        </tr>



                      </tbody>

                    </table>
                  </div>
                </div>-->
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="offset-md-2 col-md-12 padding-left-42px">

        <testinformation *ngIf="SelectedService"></testinformation>
      </div>

      <!--<div class="row" *ngIf="SelectedService">

      TESTING  {{SelectedService.Code}}
      </div>-->



    </div>
  </div>

</div>


